export enum E_LastEdited {
  TOKEN = 'token',
  USDC = 'usdc'
}
